exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\niframe[data-v-6f640f69]{width:100%;height:315px !important\n}\n", "", {"version":3,"sources":["/builds/w3-groupe/openfly/openfly/resources/assets/js/components/VideoModal.vue"],"names":[],"mappings":";AAAA,wBAAO,WAAW,uBAAuB;CAAC","file":"VideoModal.vue","sourcesContent":["iframe{width:100%;height:315px !important}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6f640f69","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/VideoModal.vue
// module id = ./node_modules/css-loader/index.js?sourceMap!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-6f640f69","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/VideoModal.vue
// module chunks = 1 2 3